/* global WMP */

import {EventEmitter} from 'events';
import {isBlacklisted} from '../utils/isBlacklisted';
import {logToActivities} from './activities';
import {logToBi} from './bi';
import {logToFedops} from './fedops';
import {getWixParams, WixParams} from './getWixParams';

export interface LogPlayerEventsOptions extends WixParams {
  sToken: string | undefined;
}

export function logPlayerEvents(eventEmitter: EventEmitter, options: LogPlayerEventsOptions) {
  options = {...options, ...getWixParams()};
  if (isBlacklisted()) {
    return;
  }
  const loggers = [logToActivities, logToBi, logToFedops];
  loggers.forEach((logger: any) => {
    try {
      logger(eventEmitter, options);
    } catch (ex) {
      console.error('Cannot initialize logger', ex); // eslint-disable-line no-console
    }
  });
}
